import React from 'react'

import Navbar2 from '../../components/navbar2/navbar2'
import ColumnHero from '../../components/columnHero/ColumnHero'

import DisclaimerRow from '../../components/disclaimerRow/DisclaimerRow'

import ContactMain from '../../components/contactMain/ContactMain'
import TopComponent from '../../components/topComponent/TopComponent'

const Contact = () => {
  const  navStyles={ backgroundColor: "#fff", position: "relative"}

  return (
    <div className="homeContainer">
    <TopComponent/>
    <Navbar2 styles2={navStyles}/>
    <ContactMain />

<ColumnHero/>

<DisclaimerRow/>

    
    </div>
  )
}

export default Contact